"use client";
import Image from "next/image";

export default function Hero() {
  return (
    <section className="max-w-screen-4xl mx-auto px-2 md:px-12 xl:px-32 mt-12">
      <div className="relative flex items-center justify-center p-3 lg:p-14 md:p-9 sm:p-4 bg-gradient-to-r from-[var(--gradient-start)] to-[var(--gradient-end)] rounded-[2rem] w-full">

        {/* Main Logo */}
        <Image
          src="/Logo_NC.png"
          alt="Gitartha Main Logo"
          width={680}
          height={250}
          priority
        />
        {/* Buttons */}
        <div
          className={`
            absolute left-1/2 -translate-x-1/2
            bottom-[-2.5rem]
            w-full z-10
            grid gap-2 md:gap-6
            grid-cols-2
            md:grid-cols-2
            lg:grid-cols-4
            ${""}
          `}
          style={{
            justifyItems: "center",
            ...(typeof window !== "undefined" && window.innerWidth >= 1024
              ? { justifyContent: "space-between" }
              : {}),
          }}
        >
          {/* {["FINANCE", "LAW", "REALTY", "GROWTH"].map((item, i) => {
            const links = {
              FINANCE: "https://tax.gitartha.in",
              LAW: "http://legal.gitartha.in/",
              REALTY: "https://realty.gitartha.in/",
              GROWTH: "https://growth.gitartha.in/",
            };

            return (
              <button
                key={i}
                onClick={() => window.open(links[item], "_blank")} // opens in new tab
                className="
        font-[BOOWIE]
        text-base md:text-lg lg:text-2xl
        bg-gradient-to-r from-[var(--primary-color)] to-[var(--secondary-color)]
        rounded-2xl text-white tracking-wide
        hover:opacity-90 transition
        flex items-center justify-center
        w-[140px] h-[48px]
        md:w-[180px] md:h-[56px]
        lg:w-[220px] lg:h-[64px]
      "
                style={{
                  minWidth: "140px",
                  maxWidth: "90vw",
                }}
              >
                {item}
              </button>
            );
          })} */}

          {/* {["FINANCE", "LAW", "REALTY", "GROWTH"].map((item, i) => (
            <button
              key={i}
              className="
                font-[BOOWIE]
                text-base md:text-lg lg:text-2xl
                bg-gradient-to-r from-[var(--primary-color)] to-[var(--secondary-color)]
                rounded-2xl text-white tracking-wide
                hover:opacity-90 transition
                flex items-center justify-center
                w-[140px] h-[48px]
                md:w-[180px] md:h-[56px]
                lg:w-[220px] lg:h-[64px]
              "
              style={{
                minWidth: "140px",
                maxWidth: "90vw",
              }}
            >
              {item}
            </button>
          ))} */}
        </div>

        {/* Spacer for buttons */}
        <div className="h-36 md:h-20" />
      </div>
    </section>
  );
}
